export default __webpack_public_path__ + "static/media/mobile_beehive_harvest_status_en.8c91593c.png";